import PrivateVars from '../PrivateVars';
import Http from '../Http';

function updateTexture(self, info) {

    const texture = PrivateVars.get(self, 'texture');
    const renderer = PrivateVars.get(self, 'renderer');
    const gl = renderer.gl;

    PrivateVars.set(self, 'ready', true);

    info = Object.assign({}, {
        magFilter: info.mipmap ? gl.LINEAR : gl.NEAREST,
        minFilter: info.mipmap ? gl.LINEAR_MIPMAP_NEAREST : gl.NEAREST,
    }, info);

    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);

    // Image has different call
    if (info.data instanceof Image) gl.texImage2D(gl.TEXTURE_2D, 0, info.format, info.format, info.type, info.data);
    else {
        console.log(`Internal Format: ${info.format}`);
        console.log(`Pixel Format: ${info.format}`);
        console.log(`Pixel Type: ${info.type}`);
        console.log(`Width: ${info.width}`);
        console.log(`Height: ${info.height}`);
        console.log(`Data: ${info.data}`);
        gl.texImage2D(gl.TEXTURE_2D, 0, info.format, info.width, info.height, 0, info.format, info.type, info.data || null);
    }

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, info.magFilter);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, info.minFilter);
    if (info.mipmap) gl.generateMipmap(gl.TEXTURE_2D);

    gl.bindTexture(gl.TEXTURE_2D, null);
}

function updateTextureFromImage(gl, texture, image) {
    updateTexture(gl, texture, { data: image });
}

const isImageParameter = x => (typeof x === 'string') || (x instanceof Image);

const ensureImage = image => {

    // Given an url, create image and set url.
    if (typeof image === 'string') {
        let url = image;
        image = new Image();
        image.src = url;
    }

    return image;
}

export default class Texture {

    /**
     * `new Texture(renderer, image)`  
     * `new Texture(renderer, image, options)`  
     * `new Texture(renderer, width, height)`  
     * `new Texture(renderer, width, height, options)`  
     */
    constructor() {

        let image, options, width, height;

        const renderer = arguments[0];
        const gl = renderer.gl;

        // Read Arguments
        switch (arguments.length) {

            case 4:
                console.log(`Creating custom texture with options.`);
                // 
                width = arguments[1];
                height = arguments[2];
                options = arguments[3];
                break;

            case 3:
                //
                if (isImageParameter(arguments[1])) {
                    console.log(`Creating texture from image and options.`);
                    image = ensureImage(arguments[1]);
                    options = arguments[2];
                } else {
                    console.log(`Creating custom texture.`);
                    width = arguments[1];
                    height = arguments[2];
                }
                break;

            case 2:
                console.log(`Creating texture from image.`);
                image = ensureImage(arguments[1]);

            default:
                throw new Error("Invalid arguments.");
        }

        // TODO: Detect power of 2?
        options = Object.assign({}, {
            mapmap: true,
            format: gl.RGBA,
            type: gl.UNSIGNED_BYTE
        }, options);

        // Create Texture
        let texture = gl.createTexture();

        // 
        PrivateVars.set(this, 'texture', texture);
        PrivateVars.set(this, 'renderer', renderer);

        if (image) {

            // Load image data
            if (image.complete) textureLoad();
            else image.onload = () => textureLoad();

            let textureLoad = () => {

                console.log(`Image loaded, updating texture.`);

                updateTexture(this, {
                    mipmap: true,
                    format: gl.RGBA,
                    type: gl.UNSIGNED_BYTE,
                    data: image
                });
            }
        } else {
            console.log(`Updating texture data.`);
            updateTexture(this, {
                width: width,
                height: height,
                data: options.data,
                mipmap: options.mipmap,
                magFilter: options.mipmap ? gl.LINEAR : gl.NEAREST,
                minFilter: options.mipmap ? gl.LINEAR_MIPMAP_NEAREST : gl.NEAREST,
                format: options.format,
                type: options.type
            });
        }
    }
}